"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _DropdownSearchbox = _interopRequireDefault(require("../DropdownSearchbox"));

var _SingleItemList = _interopRequireDefault(require("./SingleItemList"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DropdownItemList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DropdownItemList, _Component);

  var _super = _createSuper(DropdownItemList);

  function DropdownItemList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DropdownItemList);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      items: _this.props.items
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "changeItemsToDisplay", function (newItemList) {
      _this.setState({
        items: newItemList
      });
    });
    _this.changeItemsToDisplay = _this.changeItemsToDisplay.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DropdownItemList, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      if (previousProps.items !== this.props.items) {
        this.setState({
          items: this.props.items
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          hasSearch = _this$props.hasSearch,
          fullList = _this$props.items,
          _this$props$customIte = _this$props.customItem,
          customItem = _this$props$customIte === void 0 ? null : _this$props$customIte;
      var items = this.state.items;
      return (0, _preact.h)("div", {
        className: classes
      }, hasSearch && (0, _preact.h)(_DropdownSearchbox.default, {
        items: fullList,
        onChange: this.changeItemsToDisplay,
        searchPlaceholderText: this.props.searchPlaceholderText,
        searchIconWidth: this.props.searchIconWidth,
        searchIconHeight: this.props.searchIconHeight
      }), items.length === 0 && (0, _preact.h)("div", {
        className: "empty-list-message"
      }, "No results found"), customItem, items.length > 0 && items.map(function (item) {
        var _item$id;

        return (0, _preact.h)(_SingleItemList.default, {
          key: (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : item.title,
          item: item
        });
      }));
    }
  }]);
  return DropdownItemList;
}(_preact.Component);

var _default = DropdownItemList;
exports.default = _default;